import { useTranslation } from 'react-i18next';
import { faqData } from '@/mocks/categories';

export default function FAQ() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14 md:mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="w-5 h-5 flex items-center justify-center text-primary-600">
              <i className="ri-question-answer-line"></i>
            </div>
            <span className="text-primary-600 text-xs font-semibold tracking-widest uppercase">
              {t('faq.label')}
            </span>
          </div>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950">
            {t('faq.title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          <div className="md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
            {faqData.slice(0, 4).map((faq) => (
              <div
                key={faq.id}
                className="bg-background-50 rounded-2xl p-5 md:p-6 hover:bg-white transition-colors duration-200"
              >
                <div className="flex items-center gap-2 mb-3">
                  <span className="w-6 h-6 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center text-xs font-bold">
                    {faq.id}
                  </span>
                  <span className="text-foreground-400 text-xs font-medium">{faq.category}</span>
                </div>
                <h3 className="text-foreground-900 font-heading text-base md:text-lg font-semibold mb-3">
                  {faq.question}
                </h3>
                <p className="text-foreground-600 text-xs md:text-sm leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            ))}
          </div>

          <div className="relative rounded-2xl overflow-hidden min-h-[250px] md:min-h-full">
            <img
              src="https://readdy.ai/api/search-image?query=Cozy%20reading%20corner%20with%20open%20notebook%20fountain%20pen%20and%20steaming%20ceramic%20mug%20on%20reclaimed%20wood%20desk%20vintage%20style%20lamp%20with%20warm%20amber%20glow%20bookshelf%20background%20with%20trailing%20plants%20hygge%20aesthetic%20editorial%20photography%20peaceful%20atmosphere&width=600&height=900&seq=faq-v2-side&orientation=portrait"
              alt="Kakobuy FAQ"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/70 via-foreground-900/20 to-transparent"></div>
            <div className="absolute bottom-6 left-6 right-6">
              <span className="text-white text-sm font-heading font-semibold">Masz więcej pytań?</span>
              <p className="text-white/70 text-xs mt-1">Sprawdź nasz pełny artykuł o Kakobuy Spreadsheet</p>
            </div>
          </div>

          {faqData.length > 4 && (
            <div className="md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
              {faqData.slice(4).map((faq) => (
                <div
                  key={faq.id}
                  className="bg-background-50 rounded-2xl p-5 md:p-6 hover:bg-white transition-colors duration-200"
                >
                  <div className="flex items-center gap-2 mb-3">
                    <span className="w-6 h-6 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center text-xs font-bold">
                      {faq.id}
                    </span>
                    <span className="text-foreground-400 text-xs font-medium">{faq.category}</span>
                  </div>
                  <h3 className="text-foreground-900 font-heading text-base md:text-lg font-semibold mb-3">
                    {faq.question}
                  </h3>
                  <p className="text-foreground-600 text-xs md:text-sm leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}